<template>
    <div>
      <div ref="map" v-show="!isLoadingMap" id="map-container"></div>
      <v-skeleton-loader
        min-height="235"
        type="image"
        loading
        v-show="isLoadingMap"
      ></v-skeleton-loader>
      

      <div class="location-controls">
        <v-btn 
          @click="getLocation" 
          color="success" 
          v-if="!isLoadingMap" 
          small 
          class="floating-btn"
        >
          <v-icon>mdi-crosshairs-gps</v-icon>
        </v-btn>

        <div 
          class="floating-label" 
          v-if="lastLocationTimestamp"
        >
          {{ lastLocationTimestamp }}
        </div>
      </div>
    </div>
  </template>
  
  <script>
  
  import { mapActions, mapState } from "vuex";
  export default {
    name: "LeafletMap",
    props: ["destination", "origin", "position"],
    data() {
      return {
        map: null,
        isLoadingMap: true,
        markerMyPosition:null,
        lastLocationTimestamp: null

      };
    },
    computed:{
      ...mapState(["geolocationData"]),
    },
    methods: {
      configMap() {
        this.map = window.L.map(this.$refs["map"]).setView([this.origin.lat, this.origin.lng], 12);
        window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
			maxZoom: 19,
			attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
		}).addTo(this.map);
  
        window.L.layerGroup().addTo(this.map);
        const bounds = window.L.latLngBounds();
        if (this.position) {
          this.setMaker(this.position, "TU");
        } else {
          this.setMaker(this.origin, "A");
          bounds.extend(this.origin);

          this.setMaker(this.destination, "B");
          setTimeout(() => {
            bounds.extend(this.destination);
          }, 10);
          // Uncomment below if you want to display directions
          // this.displayDirections();
        }
       
        // Create an array of marker coordinates
        
        // Create a bounds object from the marker coordinates
        

        // Fit the map to the bounds with some padding
        
        setTimeout(()=>{
            this.map.invalidateSize();
            this.map.fitBounds(bounds.pad(0.3));
        }, 10);
        this.isLoadingMap = false;
        
    },
      initMap() {
        this.configMap();
      },
      setMaker(Points, Label) {
        let markerIcon ="";
        let LabelText  =Label;
        if (Label === "A") {
          LabelText = "Pickup Place";
          markerIcon = window.L.divIcon({
            className: 'custom-div-icon',
            html: `<div style="font-size: 24px;">🚩</div>`,
            iconSize: [30, 30],
            iconAnchor: [15, 30],
            popupAnchor: [0, 30]
          });
        } else {
          LabelText = "Dropoff Place";
          markerIcon = window.L.divIcon({
            className: 'custom-div-icon',
            html: `<div style="font-size: 24px;">🏁</div>`,
            iconSize: [30, 30],
            iconAnchor: [15, 30],
            popupAnchor: [0, 30]
          });
        }

        window.L.marker([Points.lat, Points.lng], { icon: markerIcon })
          .addTo(this.map)
          .bindPopup(LabelText);

      },
      async getLocation() {
        try {
          if(this.markerMyPosition){
            this.map.removeLayer(this.markerMyPosition);
          }
          await this.initGpsTracking();
          let myPosition = {lat:this.geolocationData.latitude,lng:this.geolocationData.longitude};
          const pulsingIcon = window.L.divIcon({
            className: 'custom-pulse-marker', // this is important
            iconSize: [15, 15],
            iconAnchor: [10, 10]
          });
         
          //let Label = "M";
          this.markerMyPosition= window.L.marker([myPosition.lat, myPosition.lng],{icon:pulsingIcon} ).addTo(this.map);
          this.lastLocationTimestamp = new Date().toLocaleString();
        }catch(err){
          console.log("--->",err);
        }
      },
      ...mapActions(['initGpsTracking']),
      // Uncomment below if you want to display directions
      // displayDirections() {
      //   let dS = L.Routing.control({
      //     waypoints: [
      //       L.latLng(this.origin.lat, this.origin.lng),
      //       L.latLng(this.destination.lat, this.destination.lng)
      //     ],
      //     routeWhileDragging: true
      //   }).addTo(this.map);
      // }
    },
    async mounted() {
      this.initMap();
      //this.getLocation();
      //this.initGpsTracking();
    },
  };
  </script>
  
  <style scoped>
  #map {
    height: 235px;
  }
  #map-container {
    height: 190px !important;
    z-index: 0 !important;
  }

  </style>
  <style>
    .custom-pulse-marker {
      position: relative;
      width: 10px;
      height: 10px;
      background: #1976d2; /* Google Maps blue */
      border-radius: 50%;
      border: 2px solid white;
      box-shadow: 0 0 0 0 rgba(25, 118, 210, 0.7);
      animation: pulse 2s infinite;
    }

    @keyframes pulse {
      0% {
        box-shadow: 0 0 0 0 rgba(25, 118, 210, 0.7);
      }
      70% {
        box-shadow: 0 0 0 10px rgba(25, 118, 210, 0);
      }
      100% {
        box-shadow: 0 0 0 0 rgba(25, 118, 210, 0);
      }
    }

.location-controls {
  position: absolute;
  top: 15px;
  right: 10px;
  text-align: center;
  z-index: 1000;
}

.floating-btn {
  display: block;
  margin: 0 auto;
}

.floating-label {
  margin-top: 4px;
  background-color: rgba(0, 0, 0, 0.75);
  color: white;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
}


</style>
  